import React from 'react';
import { Divider } from '@lightspeed/flame/Divider';
import Text from '@lightspeed/cirrus-text';
import { getL10nForCountryCode } from 'cirrus/Dropdown/Country/utils';
import { basePrice, calculateTaxRate, calculateTotal } from './utils';

const ReceiptSaleLines = ({ taxModel, tax1Name, tax1Rate, tax2Name, tax2Rate, countryCode }) => {
  const { symbol: currencySymbol } = getL10nForCountryCode(countryCode, [
    'currency.symbol',
  ]).currency;
  const totalTax1 = calculateTaxRate(tax1Rate);
  const totalTax2 = calculateTaxRate(tax2Rate);
  const totalTax = calculateTotal(totalTax1, totalTax2);
  const total = taxModel === 'tax_exclusive' ? calculateTotal(basePrice, totalTax) : basePrice;

  return (
    <table className="receipt-preview-salelines cr-mt-2 cr-width-full">
      <tbody>
        <tr>
          <td className="cr-pl-1 cr-text-left cr-width-full">
            <Text body>Item</Text>
          </td>
          <td className="cr-pl-2 cr-text-right">
            <Text body className="notranslate">
              {currencySymbol} {basePrice}
            </Text>
          </td>
        </tr>
        <tr>
          <td colSpan="2" className="cr-pv-1">
            <Divider />
          </td>
        </tr>

        {parseFloat(tax1Rate) ? (
          <tr>
            <td className="cr-pl-1 cr-pb-1 cr-text-right">
              <Text body bold className="cr-truncate" data-test="tax1-receipt-text">
                {tax1Name}{' '}
                <span className="notranslate">
                  ({basePrice} @ {tax1Rate}%)
                </span>
              </Text>
            </td>
            <td className="cr-pl-2 cr-pb-1 cr-text-right">
              <Text body className="cr-truncate notranslate">
                {currencySymbol} <var data-test="tax1-receipt-total">{totalTax1}</var>
              </Text>
            </td>
          </tr>
        ) : null}

        {parseFloat(tax2Rate) ? (
          <tr>
            <td className="cr-pl-1 cr-pb-1 cr-text-right">
              <Text body bold className="cr-truncate" data-test="tax2-receipt-text">
                {tax2Name}{' '}
                <span className="notranslate">
                  ({basePrice} @ {tax2Rate}%)
                </span>
              </Text>
            </td>
            <td className="cr-pl-2 cr-pb-1 cr-text-right">
              <Text body className="cr-truncate notranslate">
                {currencySymbol} <var data-test="tax2-receipt-total">{totalTax2}</var>
              </Text>
            </td>
          </tr>
        ) : null}

        <tr>
          <td className="cr-pl-1 cr-text-right">
            <Text body bold>
              Total Tax
            </Text>
          </td>
          <td className="cr-pl-2 cr-text-right">
            <Text body className="cr-truncate notranslate">
              {currencySymbol} <var data-test="tax-receipt-total">{totalTax}</var>
            </Text>
          </td>
        </tr>
        <tr>
          <td colSpan="2" className="cr-pv-1">
            <Divider />
          </td>
        </tr>
        <tr>
          <td className="cr-pl-1 cr-text-right">
            <Text body>Total</Text>
          </td>
          <td className="cr-pl-2 cr-text-right">
            <Text body bold className="cr-truncate notranslate">
              {currencySymbol} <var data-test="receipt-total">{total}</var>
            </Text>
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default ReceiptSaleLines;
